import type { QuestionSettings } from "@/types/question";

type FileSettingsProps = {
	settings: QuestionSettings;
	setSettings: (settings: QuestionSettings) => void;
};

/** Configurações de arquivo ocultas: máximo de arquivos fixo em 5. */
export const FileSettings = (_props: FileSettingsProps) => null;
